import { React } from "react";
import { ReactSVG } from "react-svg";
import NewToolTip from "./New-ToolTip";

const Button = ({
  className = "",
  type = "primary",
  iconUrl = "",
  iconComponent = "",
  text = "",
  rightText = "",
  onClick = () => { },
  disabled = false,
  iconBefore = false,
  toolTipId = "",
  TooltipComponent,
  tooltipPlace = "bottom"
}) => {
  const buttonColor = (key) => {
    switch (key) {
      case "primary":
        return `bg-REELTeal border border-transparent hover:bg-teal-200 text-white`;
      case "submit":
        return `bg-REELTeal border border-transparent hover:bg-teal-200 text-white`;
      case "dark":
        return `bg-teal-600 hover:bg-teal-600/90 text-white`;
      case "dark-o":
        return `bg-white hover:bg-gray-20 border-teal-600 hover:border-teal-600/80 text-teal-600 border`;
      case "secondary":
        return `bg-white border-teal-300 border text-teal-300 hover:text-REELTeal hover:border-hover`;
      case "danger":
        return `bg-red-300 border-red-300 border-[1px] text-white hover:text-white hover:bg-red-700`;
      case "pink":
        return `bg-lightPink border-lightPink border-[1px] text-white hover:text-white hover:bg-lightPink/90`;
      case "orange":
        return `bg-lightOrange border-lightOrange border-[1px] text-white hover:text-white hover:bg-lightOrange/90`;
      case "purple":
        return `bg-lightPurple border-lightPurple border-[1px] text-white hover:text-white hover:bg-lightPurple/90`;
      case "outline":
        return `bg-white border-gray-100 border-[1px] text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`;
      case "primary-outline":
        return `bg-white border-REELTeal border text-teal-300 hover:text-teal-300 hover:bg-gray-50`;
      case "success-outline":
        return `bg-transparent border-green-200 border text-green-200 hover:text-green-600 hover:bg-green`;
      case "pink-outline":
        return `bg-transparent border-lightPink border text-lightPink hover:text-white hover:bg-lightPink`;
      case "orange-outline":
        return `bg-transparent border-lightOrange border text-lightOrange hover:text-white hover:bg-green`;
      case "purple-outline":
        return `bg-transparent border-lightPurple border text-lightPurple hover:text-white hover:bg-green`;
      default:
        break;
    }
  };

  const hasTrailingIcon = iconUrl && !iconBefore;
  // When the icon is trailing (right side), align icon to the far right so icons line up
  // even if button text lengths differ.
  const justifyClass = rightText ? "justify-between" : hasTrailingIcon ? "justify-between" : "justify-center";

  return (
    <button
      disabled={disabled}
      type={`${type === 'submit' ? 'submit' : 'button'}`}
      onClick={onClick}
      className={`inline-flex disabled:opacity-50 rounded-[4px] border transition-all duration-300 text-body-md items-center font-semibold ${justifyClass} px-6 py-3.5 ${buttonColor(
        type
      )} ${className} `}
    >
      {iconComponent && iconBefore && (
        <span className="mr-2">{iconComponent}</span>
      )}
      {iconUrl && iconBefore && (
        <ReactSVG
          src={iconUrl ? iconUrl : "/icons/add.svg"}
          className="mr-2 w-5 self-center shrink-0"
          data-tooltip-id={toolTipId}
        />
      )}
      {rightText ? (
        <>
          <span className="truncate" data-tooltip-id={iconUrl ? "" : toolTipId} data-tooltip-place={tooltipPlace}>{text}</span>
          <span className="ml-4 text-sm opacity-90">{rightText}</span>
        </>
      ) : (
        <span
          data-tooltip-id={iconUrl ? "" : toolTipId}
          data-tooltip-place={tooltipPlace}
          className={`${hasTrailingIcon ? "flex-1 text-center" : ""}`}
        >
          {text}
        </span>
      )}
      {iconComponent && !iconBefore && (
        <span className="mr-2">{iconComponent}</span>
      )}
      {iconUrl && !iconBefore && (
        <ReactSVG
          src={iconUrl ? iconUrl : "/icons/add.svg"}
          className="w-5 ml-3 mr-3"
          data-tooltip-id={toolTipId}
        />
      )}
      {TooltipComponent && (
        <NewToolTip id={toolTipId} render={() => <TooltipComponent />} />
      )}
    </button>
  );
};

export default Button;
